/* Hooje — Fiche Collection — Quick add mobile
   Injecte un bouton "+" sur chaque carte produit (mobile uniquement).
   Au clic, ouvre un bottom sheet avec les tailles du produit.
   Sélectionner une taille → ajoute au panier → ouvre le drawer panier. */

(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  var initialised = false;

  function isMobile() { return MOBILE_MQ.matches; }

  function ensureSheet() {
    var sheet = document.getElementById('hjfc-qa-sheet');
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.id = 'hjfc-qa-sheet';
    sheet.className = 'hjfc-qa-sheet';
    sheet.setAttribute('aria-hidden', 'true');
    sheet.innerHTML =
      '<div class="hjfc-qa-sheet-panel" role="dialog" aria-modal="true" aria-label="Sélectionner une taille">' +
        '<div class="hjfc-qa-sheet-head">' +
          '<p class="hjfc-qa-sheet-title">Taille</p>' +
          '<button type="button" class="hjfc-qa-sheet-close" aria-label="Fermer">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
          '</button>' +
        '</div>' +
        '<p class="hjfc-qa-sheet-product"></p>' +
        '<ul class="hjfc-qa-sheet-list"></ul>' +
      '</div>';
    document.body.appendChild(sheet);

    var closeBtn = sheet.querySelector('.hjfc-qa-sheet-close');
    closeBtn.addEventListener('click', closeSheet);
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet) closeSheet();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet();
    });

    return sheet;
  }

  function injectButtons() {
    var cards = document.querySelectorAll('.hjfc-card');
    cards.forEach(function (card) {
      if (card.querySelector('.hjfc-qa-btn')) return;
      var imgLink = card.querySelector('.hjfc-card-img-link');
      var imgWrap = card.querySelector('.hjfc-card-img-wrap');
      if (!imgLink || !imgWrap) return;

      var url = imgLink.getAttribute('href') || '';
      var match = url.match(/\/products\/([^/?#]+)/);
      if (!match) return;
      var handle = match[1];

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hjfc-qa-btn';
      btn.setAttribute('aria-label', 'Ajout rapide');
      btn.setAttribute('data-product-handle', handle);
      btn.innerHTML = '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M7 1.5v11M1.5 7h11"/></svg>';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openSheetForProduct(handle, btn);
      });
      imgWrap.appendChild(btn);
    });
  }

  function openSheetForProduct(handle, originBtn) {
    var sheet = ensureSheet();
    var list = sheet.querySelector('.hjfc-qa-sheet-list');
    var titleEl = sheet.querySelector('.hjfc-qa-sheet-product');
    list.innerHTML = '<li><button class="hjfc-qa-sheet-btn" disabled>Chargement…</button></li>';
    titleEl.textContent = '';
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('product fetch failed');
        return r.json();
      })
      .then(function (p) {
        titleEl.textContent = p.title;

        var sizeIdx = -1;
        (p.options || []).forEach(function (opt, idx) {
          var n = (typeof opt === 'string' ? opt : opt.name || '').toLowerCase();
          if (n.indexOf('taille') >= 0 || n.indexOf('size') >= 0) sizeIdx = idx;
        });

        if (sizeIdx === -1) {
          // Pas de taille — variante unique, ajout direct
          var single = (p.variants || []).find(function (v) { return v.available; });
          if (!single) single = (p.variants || [])[0];
          if (single) {
            addVariantToCart(single.id, sheet);
          } else {
            list.innerHTML = '<li><button class="hjfc-qa-sheet-btn" disabled>Indisponible</button></li>';
          }
          return;
        }

        list.innerHTML = '';
        var seen = {};
        (p.variants || []).forEach(function (v) {
          var size = v.options && v.options[sizeIdx];
          if (!size || seen[size]) return;
          seen[size] = true;
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'hjfc-qa-sheet-btn' + (v.available ? '' : ' is-out');
          b.innerHTML = '<span>' + escapeHtml(size) + '</span>' + (v.available ? '' : '<span class="hjfc-qa-status">Épuisé</span>');
          if (v.available) {
            b.addEventListener('click', function () { addVariantToCart(v.id, sheet); });
          } else {
            b.disabled = true;
          }
          li.appendChild(b);
          list.appendChild(li);
        });

        if (!list.children.length) {
          list.innerHTML = '<li><button class="hjfc-qa-sheet-btn" disabled>Aucune taille disponible</button></li>';
        }
      })
      .catch(function (err) {
        list.innerHTML = '<li><button class="hjfc-qa-sheet-btn" disabled>Erreur — recharge la page</button></li>';
        try { console.error('hjfc quickadd', err); } catch (e) {}
      });
  }

  function closeSheet() {
    var sheet = document.getElementById('hjfc-qa-sheet');
    if (!sheet) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function addVariantToCart(variantId, sheet) {
    if (!variantId) return;
    sheet.classList.add('is-loading');
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () { return refreshCartDrawer(); })
      .then(function () {
        openCartDrawer();
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
        closeSheet();
      })
      .catch(function (err) {
        try { console.error('hjfc add', err); } catch (e) {}
        if (err && err.description) { try { alert(err.description); } catch (e) {} }
      })
      .finally(function () {
        sheet.classList.remove('is-loading');
      });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      try { drawer.open(); return; } catch (e) {}
    }
    drawer.classList.add('is-open');
    drawer.classList.remove('cart-drawer--empty');
    document.body.classList.add('cart-drawer-open');
  }

  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve();
    var sectionId = drawer.getAttribute('data-section-id');
    if (!sectionId) return Promise.resolve();
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return fetch(rootUrl + '?sections=' + sectionId, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data[sectionId]) return;
        var doc = new DOMParser().parseFromString(data[sectionId], 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        if (!fresh) return;
        drawer.className = fresh.className;
        drawer.innerHTML = fresh.innerHTML;
      })
      .catch(function (err) { try { console.error('hjfc refresh', err); } catch (e) {} });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[c];
    });
  }

  function init() {
    if (!isMobile()) return;
    initialised = true;
    injectButtons();

    // Re-inject quand la liste produits change (pagination, filtres)
    var grid = document.querySelector('.hjfc-grid');
    if (grid && window.MutationObserver) {
      var mo = new MutationObserver(function () { injectButtons(); });
      mo.observe(grid, { childList: true, subtree: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Si on passe de desktop à mobile (rotation tablette), initialiser
  if (MOBILE_MQ.addEventListener) {
    MOBILE_MQ.addEventListener('change', function (e) {
      if (e.matches && !initialised) init();
    });
  }
})();
